module.exports = __webpack_public_path__ + "img/ck_on.d18ac09c.svg";